import React from 'react'

import { Grid, TextField } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

type InputProps = {
  name: string
  type?: 'text' | 'email' | 'password'
  label?: string
  disabled?: boolean
  autoFocus?: boolean
  icon: React.ElementType<React.SVGProps<SVGSVGElement>>
}

const Input: React.FC<InputProps> = ({
  name,
  label,
  type,
  disabled,
  icon: Icon,
  autoFocus,
}) => {
  const { register, errors } = useFormContext()

  const isError = !!errors[name]
  const helperText = errors[name]?.message

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={1} sm={2} md={1} justify="center">
        <Icon />
      </Grid>
      <Grid item xs={11} sm={10} md={11}>
        <TextField
          variant="outlined"
          type={type}
          label={label}
          id={name}
          name={name}
          error={isError}
          helperText={helperText}
          inputRef={register}
          disabled={disabled}
          fullWidth
          autoFocus={autoFocus}
        />
      </Grid>
    </Grid>
  )
}

export default Input
